import { AxiosResponse } from "axios";

import { sendRequest } from "../request/axios";
import { AxiosHttpError } from "../types/error.type";
import { OrderHistory } from "../types/order.type";

export async function getOrders(limit: number, offset = 0) {
  try {
    const res = await sendRequest<never, AxiosResponse<OrderHistory>>(
      "get",
      `/orders/?limit=${limit}&offset=${offset}`
    );
    return { data: res.data, success: true };
  } catch (error) {
    console.log(error);
    const axiosError = error as AxiosHttpError;
    return {
      success: false,
      error: axiosError.response?.data,
    };
  }
}

export async function getOrderLite(id: number) {
  try {
    const res = await sendRequest<never, AxiosResponse>(
      "get",
      `/orders/${id}/lite/`
    );
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    return { data: res.data, success: true };
  } catch (error) {
    console.log(error);
    const axiosError = error as AxiosHttpError;
    return {
      success: false,
      error: axiosError.response?.data,
    };
  }
}

export async function getSingleOrder(id: number) {
  try {
    const res = await sendRequest<never, AxiosResponse>("get", `/orders/${id}`);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    return { data: res.data, success: true };
  } catch (error) {
    console.log(error);
    const axiosError = error as AxiosHttpError;
    return {
      success: false,
      error: axiosError.response?.data,
    };
  }
}

export async function getReceipt(orderId: number) {
  try {
    const res = await sendRequest<never, AxiosResponse<Blob>>(
      "get",
      `/orders/${orderId}/?output=pdf`,
      undefined,
      { responseType: "blob" }
    );
    return { data: res.data, success: true };
  } catch (error) {
    console.log(error);
    const axiosError = error as AxiosHttpError;
    return {
      success: false,
      error: axiosError.response?.data,
    };
  }
}
